import { render, staticRenderFns } from "./VisualizationVideo.vue?vue&type=template&id=08628022&scoped=true&"
import script from "./VisualizationVideo.vue?vue&type=script&lang=js&"
export * from "./VisualizationVideo.vue?vue&type=script&lang=js&"
import style0 from "./VisualizationVideo.vue?vue&type=style&index=0&id=08628022&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08628022",
  null
  
)

export default component.exports